import { render, staticRenderFns } from "./PayPeriodSelector.vue?vue&type=template&id=8b56044a&scoped=true&"
import script from "./PayPeriodSelector.vue?vue&type=script&lang=js&"
export * from "./PayPeriodSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56044a",
  null
  
)

export default component.exports